import { NumberInputValue } from '../../types';

export function isValidInput(min: NumberInputValue, max: NumberInputValue): boolean {
  if (min == null) {
    return false;
  }

  if (max == null) {
    return false;
  }

  return min > max;
}
